import { CardTextButtons } from '@gerdau/hefesto/CardTextButtons';
import { Title } from '@gerdau/hefesto/Title';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { ERoutes } from '../../../routes';
import { EOrdersRoutes } from '../orders.routes';
import { Container } from './styles';

const SteelTypeChoose: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const goToLongSteel = () => {
    prepareAndSendTagging(
      'button:verPedidosDeAcosLongos',
      'meus_pedidos_ver_pedidos_de_acos_longos'
    );
    history.push(`${ERoutes.ORDERS}/${EOrdersRoutes.LONG_STEEL_ORDERS}`);
  };

  const goToFabrication = () => {
    prepareAndSendTagging(
      'button:verPedidosDeCorteEDobra',
      'meus_pedidos_ver_pedidos_de_corte_e_dobra'
    );
    history.push(`${ERoutes.ORDERS}/${EOrdersRoutes.FABRICATION_ORDERS}`);
  };

  const { screenName } = getTaggingInformationScreen(window.location.pathname);

  const prepareAndSendTagging = (itemName: string, itemDescription: string) => {
    dispatch(
      sendTagging({
        screenName: screenName,
        event: 'click',
        itemName: itemName,
        itemDescription: itemDescription,
        page: window.location.pathname
      })
    );
  };

  useEffect(() => {
    dispatch(
      sendTagging({
        screenName: screenName,
        event: 'page_view',
        page: window.location.pathname
      })
    );
  }, [dispatch, screenName]);

  return (
    <Container>
      <header>
        <div>
          <Title level={1}>Meus pedidos</Title>
          <span>Selecione um segmento para acompanhar seus pedidos:</span>
        </div>
      </header>

      <div className="cards">
        <div className="cards-container">
          <div className="card">
            <CardTextButtons
              title={'Aços longos'}
              description={
                'Arames, barras e perfis, barras trefiladas, malhas, pregos, tarugos, telas, treliças, vergalhões, entre outros.'
              }
              buttonProps={{
                label: 'Ver pedidos de aços longos e aços planos',
                onClick: () => {
                  goToLongSteel();
                }
              }}
            />
          </div>
          <div className="card">
            <CardTextButtons
              title={'Corte e dobra'}
              description={
                'Aços longos cortados e dobrados conforme meus projetos.'
              }
              buttonProps={{
                label: 'Ver pedidos de corte e dobra',
                onClick: () => {
                  goToFabrication();
                }
              }}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SteelTypeChoose;
